export default  {
    knobX: 88,
    knobY: 88,
    svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="184px" height="184px" viewBox="0 0 184 184" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="50%" gradientTransform="translate(0.500000,0.500000),rotate(90.000000),scale(1.000000,0.979317),translate(-0.500000,-0.500000)" id="cfc17ca7-d607-ce44-d575-7ed4eff5bf3a">
            <stop stop-color="#6B6767" offset="0%"/>
            <stop stop-color="#514F4F" offset="100%"/>
        </radialGradient>
        <path d="M174.99856,101.33904 C175.6568,96.98832 176,92.532 176,87.99824 C176,83.46448 175.6568,79.01168 174.99856,74.66096 L152.79792,63.76304 C152.23472,62.25824 151.62224,60.77632 150.9552,59.32432 L158.94384,35.92864 C153.648,28.71968 147.28032,22.352 140.07488,17.05616 L116.67744,25.0448 C115.22544,24.38128 113.74528,23.76704 112.23872,23.20384 L101.3408,1.00496 C96.99008,0.34144 92.53376,0 88,0 C83.46624,0 79.01168,0.34144 74.66096,1.00496 L63.76304,23.20384 C62.25824,23.76704 60.77808,24.38128 59.32432,25.0448 L35.92688,17.05616 C28.72144,22.352 22.35376,28.72144 17.05616,35.92688 L25.04304,59.32256 C24.38128,60.77456 23.7688,62.25648 23.20384,63.76128 L1.00496,74.66096 C0.3432,79.01168 0,83.46448 0,87.99824 C0,92.532 0.3432,96.98832 1.00496,101.33904 L23.20384,112.23696 C23.7688,113.74176 24.38128,115.22192 25.04304,116.67744 L17.05616,140.07312 C22.35376,147.27856 28.72144,153.64624 35.92688,158.9456 L59.32256,150.95872 C60.77632,151.62048 62.25648,152.23296 63.76128,152.79616 L74.6592,174.9968 C79.01168,175.6568 83.46624,176 88,176 C92.53376,176 96.99008,175.6568 101.3408,174.9968 L112.23696,152.79616 C113.74352,152.23296 115.22368,151.62048 116.6792,150.95872 L140.07312,158.9456 C147.27856,153.64624 153.64624,147.27856 158.94208,140.07312 L150.9552,116.6792 C151.62224,115.22368 152.23472,113.74352 152.79792,112.23872 L174.99856,101.33904 Z" id="3d32dfe4-dbcb-2346-abad-7e1e4b827ec7"/>
        <filter x="-3.7%" y="-3.7%" width="107.4%" height="107.4%" filterUnits="objectBoundingBox" id="d809596d-b20c-12e6-2d5a-4927f2b5b67c">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="50%" id="2a3e73d2-749d-1bfe-4c21-2bd26b640a7a">
            <stop stop-color="#868282" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#5E5A5A" stop-opacity="0.985252491" offset="100%"/>
        </radialGradient>
        <path d="M87.9930302,142 C58.1714064,142 34,117.820341 34,87.9953536 C34,58.1750129 58.1714064,34 87.9930302,34 C117.814654,34 142,58.1750129 142,87.9953536 C142,117.820341 117.814654,142 87.9930302,142 Z" id="a33d9e15-c718-060a-4cec-9961673ab2b8"/>
        <filter x="-5.6%" y="-5.6%" width="111.1%" height="111.1%" filterUnits="objectBoundingBox" id="9b234fef-2b63-9a4d-7e68-e76e43a9bb53">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <filter x="-5.6%" y="-5.6%" width="111.1%" height="111.1%" filterUnits="objectBoundingBox" id="5c533892-deb2-8395-8790-f7e63757ddbe">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <path d="M85,1.24236701 C86.8525183,1.080789 88.269185,1 89.25,1 C90.230815,1 91.6474817,1.080789 93.5,1.24236701 L93.5,34.242367 L85,34.242367 L85,1.24236701 Z" id="4c4cbc2e-e928-a816-ec3f-db587c4008ee"/>
        <filter x="-11.8%" y="-3.0%" width="123.5%" height="106.0%" filterUnits="objectBoundingBox" id="5f740091-fe42-c079-9457-fd3b063b6de7">
            <feGaussianBlur stdDeviation="0.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        
        <filter x="-6.7%" y="-14.3%" width="113.3%" height="128.6%" filterUnits="objectBoundingBox" id="3dcf5a34-bd69-fd0b-ac9e-4457a306b1bb">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.639215686   0 0 0 0 0.784313725   0 0 0 0 0.956862745  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s18" transform="translate(4.000000, 4.000000)">
            <g id="container">
                <g id="knob">
                    <g id="Shape" fill-rule="nonzero">
                        <use fill="black" fill-opacity="1" filter="url(#d809596d-b20c-12e6-2d5a-4927f2b5b67c)" xlink:href="#3d32dfe4-dbcb-2346-abad-7e1e4b827ec7"/>
                        <use stroke="#726E6E" stroke-width="1" fill="url(#cfc17ca7-d607-ce44-d575-7ed4eff5bf3a)" fill-rule="evenodd" xlink:href="#3d32dfe4-dbcb-2346-abad-7e1e4b827ec7"/>
                    </g>
                    <g id="Path">
                        <use fill="black" fill-opacity="1" filter="url(#9b234fef-2b63-9a4d-7e68-e76e43a9bb53)" xlink:href="#a33d9e15-c718-060a-4cec-9961673ab2b8"/>
                        <use fill="url(#2a3e73d2-749d-1bfe-4c21-2bd26b640a7a)" fill-rule="evenodd" xlink:href="#a33d9e15-c718-060a-4cec-9961673ab2b8"/>
                        <use fill="black" fill-opacity="1" filter="url(#5c533892-deb2-8395-8790-f7e63757ddbe)" xlink:href="#a33d9e15-c718-060a-4cec-9961673ab2b8"/>
                    </g>
                    <g id="Rectangle-3">
                        <use fill="#D8D8D8" fill-rule="evenodd" xlink:href="#4c4cbc2e-e928-a816-ec3f-db587c4008ee"/>
                        <use fill="black" fill-opacity="1" filter="url(#5f740091-fe42-c079-9457-fd3b063b6de7)" xlink:href="#4c4cbc2e-e928-a816-ec3f-db587c4008ee"/>
                    </g>
                </g>
            </g>
            <g id="label-copy-2" transform="translate(43.000000, 67.000000)" fill="#A3C8F4" fill-opacity="1">
                <g id="labeltext">
                    <text id="24a3a389-cad1-e9da-a465-0be9700370a6" font-family="Helvetica" font-size="34" font-weight="normal" fill="#A3C8F4" class="text-10" filter="url(#3dcf5a34-bd69-fd0b-ac9e-4457a306b1bb)">
            <tspan x="2.45849609" y="33">10.10</tspan>
        </text>
                    <text id="5a8b9e3f-a73a-6162-7e90-df64bb4da446" font-family="Helvetica" font-size="34" font-weight="normal" fill="#A3C8F4" class="text-10">
            <tspan x="2.45849609" y="33">10.10</tspan>
        </text>
                </g>
            </g>
        </g>
    </g>
</svg>
`,
updateAttributes: [
    {
      element: "#labeltext text tspan",
      content: (props, value) => {
        return value.toFixed(0);
      },
      attrs: [
        {
          name: "text-anchor",
          value: (props, value) => {
            return "middle";
          }
        },
        {
          name: "x",
          value: (props, value) => {
            return "47";
          }
        }
      ]
    }
  ]
}